import { render, staticRenderFns } from "./Gettouch.vue?vue&type=template&id=324234b2&scoped=true&"
import script from "./Gettouch.vue?vue&type=script&lang=js&"
export * from "./Gettouch.vue?vue&type=script&lang=js&"
import style0 from "./Gettouch.vue?vue&type=style&index=0&id=324234b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324234b2",
  null
  
)

export default component.exports